import { Icon } from '@eti/components';
import { css, etiColors } from '@eti/styles';
import { DIRECTIONS, useDirection } from '@eti/providers';
import PropTypes from 'prop-types';
import { resetButtonStyles } from '../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const getIconRotationDirection = (docDirection, direction) => {
  if (docDirection === DIRECTIONS.LTR) {
    return direction === 'previous' ? 'rotate(90deg)' : 'rotate(-90deg)';
  }
  return direction === 'previous' ? 'rotate(-90deg)' : 'rotate(90deg)';
};
const iconStyles = (docDirection, direction, disabled) => css`
  fill: ${disabled ? etiColors.grayScale[6] : etiColors.grayScale[10]};
  height: 20px;
  transform: ${getIconRotationDirection(docDirection, direction)};
  width: 20px;
`;
const travelerButtonStyles = disabled => css`
  cursor: ${disabled ? 'default' : 'pointer'};
  height: 20px;
  margin-left: 13px;
  margin-right: 13px;
  ${resetButtonStyles};
  overflow: hidden;
  width: 22px;
`;
const SwitchTravelerButton = _ref => {
  let {
    navigateTo,
    onClick,
    isDisabled
  } = _ref;
  const {
    direction
  } = useDirection();
  return /*#__PURE__*/_jsx("button", {
    className: travelerButtonStyles(isDisabled),
    "data-testid": `seatMap-travelerSwitch-${navigateTo}Button`,
    onClick: onClick,
    type: "button",
    children: /*#__PURE__*/_jsx(Icon, {
      className: iconStyles(direction, navigateTo, isDisabled),
      id: "chevron-down"
    })
  });
};
SwitchTravelerButton.propTypes = {
  isDisabled: PropTypes.bool,
  navigateTo: PropTypes.string,
  onClick: PropTypes.func
};
export default SwitchTravelerButton;
//# sourceMappingURL=SwitchTravelerButton.js.map